import instanceQuery from 'graphql/queries/product/ProductConfigQuery.graphql';
import defaultQuery from 'graphql/queries/product/ProductConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/product/ProductConfigMutation.graphql';
import fragment from 'graphql/fragments/product/ProductConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const ProductConfig = {
  type: 'ProductConfig',
  title: 'Product Configuration',
  formTitle: 'Product Configuration',
  formUrl: '/Products/ProductConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'PRODUCT_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default ProductConfig;
